module.exports = __webpack_public_path__ + "static/consult-7e0dee739d0f5b72bc4df15e803eef21.jpg";